import { Component, OnChanges, SimpleChanges, Input } from '@angular/core';

import { HttpService } from '../../core/http/http.service';
import { PopoverInput } from './base/popover-input';

@Component({
	selector: 'popover-radio-button-list',
	template: require('./popover-radio-button-list.component.html')
})
export class PopoverRadioButtonListComponent extends PopoverInput implements OnChanges {

	constructor(private httpService: HttpService) { super() }

    ngOnChanges(changes: SimpleChanges) {
        if (changes['originalValue']) {
			this.dirtyValue = changes['originalValue'].currentValue;
        }
	}

	@Input() valueField: string = "id";
	@Input() textField: string = "name";

	@Input() items: any[];

	@Input('itemsUrl')
	set itemsUrl(url: string) {
		this.httpService.get<any[]>(url).then(result => this.items = result);
	};


	@Input('value')
	set setValue(val: any) {
		this.originalValue = val;
		this.dirtyValue = val;
	}

	getText(i: number) {
		var itm = this.items.find(x => x[this.valueField] === i);

		if (!itm)
			return "??";

		return itm[this.textField];
	}


}




// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular2-router-loader/src!./TypeScript/shared/editable-popover/popover-radio-button-list.component.ts